// refs.ts
var HardRef = class {
  _ref;
  constructor(target) {
    this._ref = target;
  }
  deref() {
    return this._ref;
  }
};
var WeakRef = "WeakRef" in globalThis ? globalThis.WeakRef : (
  /* coverage ignore next */
  HardRef
);
export {
  HardRef,
  WeakRef
};
//# sourceMappingURL=refs.mjs.map
